import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Grid } from '@mui/material';
import {
  WsChromeLogo,
  WsConfigureCareerPageLogo,
  WsOutlookExtensionLogo,
  WsSendMassMailsLogo,
  WsExternalJobboardLogo,
} from 'wisestep-base';

import { useUserContext, useWorkspaceContext } from '../../../context';
import AppsCard from '../AppsCard/AppsCard';

const AppsMenu = () => {
  const user = useUserContext();
  const admin = useWorkspaceContext();
  const workspaceUser = user?.workspaceUser?.authorities;
  const isAdmin = (workspaceUser?.includes('ROLE_ADMIN') || admin.owns) ?? false;
  const outlookDesc =
    'Wisestep Add-in for outlook helps you automatically Import Candidate Resumes into your database on the cloud and helps you Post and Distribute Jobs right from your inbox.';
  const chromeDesc =
    'Add Wisestep extension in your chrome browser to automate the recruitment process and source the candidates';
  const massmailingDesc =
    'Integrate your email account with Wisestep and manage your mass mailing and vendor communication through wisestep for seamless experience.';
  const careerPageDesc =
    'Configure your career page through Wisestep and create beautiful career pages. With Wisestep integration, you can change add or modify any of the details of your career page with a few clicks.';
  const externalJobDesc =
    'With our integration with Premium Job Boards you can post and receive applications for all your job listings on Wisestep with a single click.';
  const cvuploadapp =
    'Effortlessly upload and organize resumes with our CV Uploader App, streamlining your candidate screening process.';
  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      <Grid item xs={6}>
        <AppsCard
          title="Chrome Extension"
          Logo={WsChromeLogo}
          href="https://chrome.google.com/webstore/detail/recruitment-automation-by/dhbkmcoahmolllnkkpgniamjkldaemgm"
          isAdmin={true}
          description={chromeDesc}
        />
      </Grid>
      <Grid item xs={6}>
        <AppsCard
          title="Send Mass Mails"
          Logo={WsSendMassMailsLogo}
          href="/vendors"
          isAdmin={true}
          description={massmailingDesc}
        />
      </Grid>
      <Grid item xs={6}>
        <AppsCard
          title="Outlook Extension"
          Logo={WsOutlookExtensionLogo}
          href="https://appsource.microsoft.com/en-us/product/office/WA200002649?tab=Overview"
          isAdmin={true}
          description={outlookDesc}
        />
      </Grid>
      <Grid item xs={6}>
        <AppsCard
          title="Configure Career Page"
          Logo={WsConfigureCareerPageLogo}
          href="/app-settings/career-page/general"
          isAdmin={isAdmin}
          description={careerPageDesc}
        />
      </Grid>
      <Grid item xs={6}>
        <AppsCard
          title="External Job Board"
          Logo={WsExternalJobboardLogo}
          href="/job-boards"
          isAdmin={isAdmin}
          description={externalJobDesc}
        />
      </Grid>
      <Grid item xs={6}>
        <AppsCard
          title="CV Uploader App"
          Logo={FileUploadIcon}
          href="/bulk-importer"
          isAdmin={isAdmin}
          description={cvuploadapp}
        />
      </Grid>
    </Grid>
  );
};

export default AppsMenu;
